import { SettingsState } from './types';

export const selectUserPreferences = (state: SettingsState) => state.settings.preferences;
export const selectUserAvatarUrl = (state: SettingsState) =>
  state.settings.preferences?.details?.avatarUrl;
